import React from 'react';
import clsx from 'clsx';

import { Dialog } from '@shared/components';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import WarningIcon from '@assets/icons/error.svg';

import useStyles from './style';

const noop = () => {};

const SyncSuccessComponent = ({ isOpen = false, onClose = noop }) => {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.syncSuccesModal }}
      open={isOpen}
      onClose={onClose}
    >
      <Dialog.Title hasClose />
      <Dialog.Content className='align-center'>
        <div className='mt-5 pl-5 pr-5'>
          <Typography variant='h5' className='text-bold'>
            SYNC COMPLETED
          </Typography>
          <div className='mt-10 mb-10'>
            <img alt='warning' src={WarningIcon} width={70} />
          </div>

          <Typography variant='h6' className={clsx('mt-2 mb-5 color-error')}>
            Errors Detected
          </Typography>
          <Typography variant='body2'>
            Please review error list for more details on unsynced items.
          </Typography>
          <div className='mt-5'>
            <Button variant='contained' color='primary' onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

export default SyncSuccessComponent;
